"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryEventVariantsComponent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const QueryEventVariantsJSONModel_1 = require("src/hello_assets/src/components/model/common/queryEventVariant/QueryEventVariantsJSONModel");
const EventsDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsDataProvider");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const EventJSONModel_1 = require("src/hello_assets/src/components/model/common/event/EventJSONModel");
const QueryEventVariantJSONModel_1 = require("src/hello_assets/src/components/model/common/queryEventVariant/QueryEventVariantJSONModel");
const antd_1 = require("antd");
const EventDeleteComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/event/EventDeleteComponent");
const EventAddComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/event/EventAddComponent");
const QueryEventVariantNameComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/event/queryEventVariant/QueryEventVariantNameComponent");
const ICEventQueryUtil_1 = require("src/hello_assets/src/util/ICEventQueryUtil");
const EventConditionOperatorComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/event/EventConditionOperatorComponent");
const EventConditionStatementComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/event/EventConditionStatementComponent");
function QueryEventVariantsComponent(props) {
    const eventsDataContext = (0, EventsDataProvider_1.useEventsDataContext)();
    const queryEventVariantsJSONModel = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        return new QueryEventVariantsJSONModel_1.QueryEventVariantsJSONModel(props.queryEventVariantsSerializedState);
    }, [props.queryEventVariantsSerializedState], lodash_1.default.isEqual);
    const onChangeEventName = (0, react_1.useCallback)((eventUniqueId, value) => {
        // console.log("onChangeEventName: ========>");
        // console.log("serializedState", _.cloneDeep(queryEventVariantsJSONModel.serialize()));
        // console.log("eventUniqueId", eventUniqueId);
        // console.log("value", value);
        const queryEventVariantJSONModel = queryEventVariantsJSONModel.getQueryEventVariantJSONModel(eventUniqueId);
        // console.log("queryEventVariantJSONModel?.serialize() before", _.cloneDeep(queryEventVariantJSONModel?.serialize()));
        queryEventVariantJSONModel === null || queryEventVariantJSONModel === void 0 ? void 0 : queryEventVariantJSONModel.setValue(queryEventVariantCompositeFromValueType(value));
        // console.log("queryEventVariantJSONModel?.serialize() after", _.cloneDeep(queryEventVariantJSONModel?.serialize()));
        const serializedState = queryEventVariantsJSONModel.serialize();
        // console.log("serializedState", _.cloneDeep(serializedState));
        props.onChange(serializedState, props.context);
    }, [queryEventVariantsJSONModel, props.onChange, props.context]);
    const onClickDeleteEvent = (0, react_1.useCallback)((eventUniqueId) => {
        queryEventVariantsJSONModel.removeItem(eventUniqueId);
        if (!queryEventVariantsJSONModel.hasItems()) {
            queryEventVariantsJSONModel.addQueryEventVariantJSONModel(new QueryEventVariantJSONModel_1.QueryEventVariantJSONModel());
        }
        const serializedState = queryEventVariantsJSONModel.serialize();
        props.onChange(serializedState, props.context);
    }, [queryEventVariantsJSONModel, props.onChange, props.context]);
    const onClickAddEvent = (0, react_1.useCallback)(() => {
        queryEventVariantsJSONModel.addQueryEventVariantJSONModel(new QueryEventVariantJSONModel_1.QueryEventVariantJSONModel());
        const serializedState = queryEventVariantsJSONModel.serialize();
        props.onChange(serializedState, props.context);
    }, [queryEventVariantsJSONModel, props.onChange, props.context]);
    const eventNames = (0, react_1.useMemo)(() => {
        return eventsDataContext.eventNamesState.data || [];
    }, [eventsDataContext.eventNamesState.data]);
    const eventCanBeAdded = queryEventVariantsJSONModel.getItemsCount() < 10;
    return React.createElement("div", { className: "eventsWithPropertiesBlock" },
        React.createElement("div", null, queryEventVariantsJSONModel.getItemsSortedArray().map((event, eventIdx) => {
            var _a;
            const shouldShowFakeConditionComponent = ((_a = props.config) === null || _a === void 0 ? void 0 : _a.showFakeAndComponentFromSecondRow) === true && eventIdx > 0;
            return React.createElement(antd_1.Row, { key: event.uniqueId, gutter: 12, className: "eventsWithPropertiesBlock-eventRow" },
                shouldShowFakeConditionComponent && React.createElement(antd_1.Col, null,
                    React.createElement(EventConditionOperatorComponent_1.EventConditionOperatorComponent, null)),
                React.createElement(antd_1.Col, { span: shouldShowFakeConditionComponent ? 10 : 16, lg: shouldShowFakeConditionComponent ? 6 : 8 },
                    React.createElement(QueryEventVariantNameComponent_1.QueryEventVariantNameComponent, { uniqueId: event.uniqueId, index: eventIdx, value: valueTypeFromQueryEventVariantComposite(event.data.queryEventVariantJSONModel.getValue()), onChange: onChangeEventName, eventNames: eventNames, onFetch: eventsDataContext.fetchEventNames, loading: eventsDataContext.eventNamesState.inProgress, transformOptions: props.transformOptions })),
                shouldShowFakeConditionComponent && React.createElement(antd_1.Col, null,
                    React.createElement(EventConditionStatementComponent_1.EventConditionStatementComponent, null)),
                React.createElement(antd_1.Col, null,
                    React.createElement(EventDeleteComponent_1.EventDeleteComponent, { uniqueId: event.uniqueId, onClick: onClickDeleteEvent })));
        })),
        React.createElement(antd_1.Row, { style: { marginTop: 10 } },
            React.createElement(antd_1.Col, null,
                React.createElement(EventAddComponent_1.EventAddComponent, { onClick: onClickAddEvent, disabled: !eventCanBeAdded }))));
}
exports.QueryEventVariantsComponent = QueryEventVariantsComponent;
const queryEventVariantCompositeFromValueType = (value) => {
    if (value) {
        switch (value.type) {
            case "newUser":
                return { type: "newUser" };
            case "event":
                const eventJSONModel = new EventJSONModel_1.EventJSONModel();
                eventJSONModel.setName(value.name);
                return {
                    type: "event",
                    event: eventJSONModel
                };
            case "session":
                return { type: "session" };
            case "anyEvent":
                return { type: "anyEvent" };
        }
    }
    return undefined;
};
const valueTypeFromQueryEventVariantComposite = (queryEventVariantComposite) => {
    if (queryEventVariantComposite) {
        switch (queryEventVariantComposite.type) {
            case "newUser":
                return { type: "newUser", value: "newUser", label: ICEventQueryUtil_1.QueryEventVariantSpecialEventNames.newUser };
            case "event":
                if (queryEventVariantComposite.event.isFilled()) {
                    const name = `${queryEventVariantComposite.event.getName()}`;
                    return { type: "event", name: name, value: name, label: name };
                }
                break;
            case "session":
                return { type: "session", value: "session", label: ICEventQueryUtil_1.QueryEventVariantSpecialEventNames.session };
            case "anyEvent":
                return { type: "anyEvent", value: "anyEvent", label: ICEventQueryUtil_1.QueryEventVariantSpecialEventNames.anyEvent };
        }
    }
    return undefined;
};
